import Logger from '@noths/logger/build/client';
import GeoLocatorService from '../GeoLocatorService';
import Environment from '../../utils/Environment';

export default class ReCaptchaService {
  static async requiresReCaptcha() {
    try {
      if (this.isSuitableEnvironment()) {
        const location = await GeoLocatorService.getUserLocation();
        return location.data.country.code !== 'GB';
      }
    } catch (error) {
      Logger.error(error, { extra: { description: 'ReCaptcha check failed' } });
    }
    return false;
  }

  static isSuitableEnvironment() {
    return Environment.isProduction();
  }
}
